import { RoomForPatient } from '../../services/room';
import { UserSubscriptionType } from '../../services/subscriptions';
import { useService } from '../useService';

type UsePatientPaidStatusReturn = {
  isPaidUser: boolean;
  roomOwnerSubscriptionType: UserSubscriptionType;
  freeOrPaid: 'free' | 'paid';
};

export const usePatientPaidStatus = (
  room?: RoomForPatient | null,
): UsePatientPaidStatusReturn => {
  const isProvider = useService('$context') === 'provider';
  const hasOwner = Boolean(room?.owner);

  if (isProvider || !hasOwner) {
    return {
      isPaidUser: false,
      roomOwnerSubscriptionType: UserSubscriptionType.Free,
      freeOrPaid: 'free',
    };
  }

  const isPaidUser =
    room?.owner?.subscriptionType !== UserSubscriptionType.Free;

  const roomOwnerSubscriptionType =
    room?.owner?.subscriptionType ?? UserSubscriptionType.Free;

  return {
    isPaidUser,
    roomOwnerSubscriptionType,
    freeOrPaid: isPaidUser ? 'paid' : 'free',
  };
};
